var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrdArr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91 0.0900879L6.5 4.67009L11.09 0.0900879L12.5 1.50009L6.5 7.50009L0.5 1.50009L1.91 0.0900879Z",
    fill: "url(#paint0_linear_959_6781)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_959_6781",
    x1: 0.5,
    y1: 7.50009,
    x2: 7.08351,
    y2: -1.2987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F47EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrdArr);
export default __webpack_public_path__ + "static/media/grd-arr.27493a5f89ed803c53f00889c9a851a4.svg";
export { ForwardRef as ReactComponent };